import DevelopusTreeTableBodyUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableBodyUIModel'
import { LicenseUI, getLicenseTreeTable } from './LicenseUI'

export type LicensesUI = {
  licenses: LicenseUI[]
}

export const getLicensesTreeTable = (
  licensesUI: LicensesUI,
): DevelopusTreeTableBodyUIModel => {
  const licenses = licensesUI.licenses.filter(
    (license: LicenseUI) => license.success,
  )

  return new DevelopusTreeTableBodyUIModel(
    licenses.map((license: LicenseUI) => getLicenseTreeTable(license)),
  )
}
